/**
 * A non-throwing JSON stringify helper.
 */
export function jsonStringifyNoThrow(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (err) {
        return undefined;
    }
}
//# sourceMappingURL=util.js.map